import React, { useState } from 'react';
import { Sidebar } from '../../components/Sidebar';
import { Header } from '../../components/Header';
import { ShieldCheckIcon, AlertTriangleIcon, FileTextIcon, DownloadIcon, PlusIcon, CheckCircleIcon, ClockIcon } from 'lucide-react';
import { VIOLATIONS } from '../../data/brandMockData';
import { CreatePolicyModal } from '../../components/brand/CreatePolicyModal';
export function ComplianceDashboard() {
  const [isCreatePolicyOpen, setIsCreatePolicyOpen] = useState(false);
  return <div className="flex w-full min-h-screen bg-gray-50" data-id="element-1962">
      <Sidebar data-id="element-1963" />
      <main className="flex-1 overflow-y-auto" data-id="element-1964">
        <Header data-id="element-1965" />
        <div className="px-8 py-8" data-id="element-1966">
          <div className="flex items-center justify-between mb-8" data-id="element-1967">
            <div data-id="element-1968">
              <h1 className="text-2xl font-bold text-gray-900" data-id="element-1969">
                Compliance & Governance
              </h1>
              <p className="text-gray-500 mt-1" data-id="element-1970">
                Monitor network compliance and manage policies
              </p>
            </div>
            <div className="flex gap-3" data-id="element-1971">
              <button className="flex items-center gap-2 px-4 py-2 bg-white border border-gray-200 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50" data-id="element-1972">
                <DownloadIcon size={16} data-id="element-1973" />
                Export Report
              </button>
              <button onClick={() => setIsCreatePolicyOpen(true)} className="flex items-center gap-2 px-4 py-2 bg-blue-600 rounded-lg text-sm font-medium text-white hover:bg-blue-700 shadow-sm" data-id="element-1974">
                <PlusIcon size={16} data-id="element-1975" />
                Create Policy
              </button>
            </div>
          </div>

          <div className="grid grid-cols-3 gap-6 mb-8" data-id="element-1976">
            {/* Compliance Score */}
            <div className="bg-white rounded-xl border border-gray-200 p-6 shadow-sm flex flex-col items-center justify-center text-center" data-id="element-1977">
              <div className="relative w-40 h-40 mb-4" data-id="element-1978">
                <svg className="w-full h-full transform -rotate-90" data-id="element-1979">
                  <circle cx="80" cy="80" r="70" stroke="#f3f4f6" strokeWidth="12" fill="none" data-id="element-1980" />
                  <circle cx="80" cy="80" r="70" stroke="#10b981" strokeWidth="12" fill="none" strokeDasharray={2 * Math.PI * 70} strokeDashoffset={2 * Math.PI * 70 * (1 - 0.87)} className="transition-all duration-1000 ease-out" data-id="element-1981" />
                </svg>
                <div className="absolute inset-0 flex flex-col items-center justify-center" data-id="element-1982">
                  <span className="text-4xl font-bold text-gray-900" data-id="element-1983">87</span>
                  <span className="text-sm text-gray-500" data-id="element-1984">Score</span>
                </div>
              </div>
              <h3 className="text-lg font-semibold text-gray-900" data-id="element-1985">
                Network Compliance
              </h3>
              <p className="text-sm text-gray-500 mt-1" data-id="element-1986">
                +2.4% from last month
              </p>
            </div>

            {/* Violations by Severity */}
            <div className="bg-white rounded-xl border border-gray-200 p-6 shadow-sm" data-id="element-1987">
              <h3 className="text-lg font-semibold text-gray-900 mb-6" data-id="element-1988">
                Violations by Severity
              </h3>
              <div className="space-y-4" data-id="element-1989">
                <div className="flex items-center gap-4" data-id="element-1990">
                  <div className="w-24 text-sm font-medium text-red-600" data-id="element-1991">
                    Critical
                  </div>
                  <div className="flex-1 bg-red-50 rounded-full h-3" data-id="element-1992">
                    <div className="bg-red-500 h-3 rounded-full" style={{
                    width: '15%'
                  }} data-id="element-1993"></div>
                  </div>
                  <div className="w-8 text-right text-sm font-bold text-gray-900" data-id="element-1994">
                    2
                  </div>
                </div>
                <div className="flex items-center gap-4" data-id="element-1995">
                  <div className="w-24 text-sm font-medium text-orange-600" data-id="element-1996">
                    High
                  </div>
                  <div className="flex-1 bg-orange-50 rounded-full h-3" data-id="element-1997">
                    <div className="bg-orange-500 h-3 rounded-full" style={{
                    width: '30%'
                  }} data-id="element-1998"></div>
                  </div>
                  <div className="w-8 text-right text-sm font-bold text-gray-900" data-id="element-1999">
                    4
                  </div>
                </div>
                <div className="flex items-center gap-4" data-id="element-2000">
                  <div className="w-24 text-sm font-medium text-amber-600" data-id="element-2001">
                    Medium
                  </div>
                  <div className="flex-1 bg-amber-50 rounded-full h-3" data-id="element-2002">
                    <div className="bg-amber-500 h-3 rounded-full" style={{
                    width: '45%'
                  }} data-id="element-2003"></div>
                  </div>
                  <div className="w-8 text-right text-sm font-bold text-gray-900" data-id="element-2004">
                    6
                  </div>
                </div>
                <div className="flex items-center gap-4" data-id="element-2005">
                  <div className="w-24 text-sm font-medium text-blue-600" data-id="element-2006">
                    Low
                  </div>
                  <div className="flex-1 bg-blue-50 rounded-full h-3" data-id="element-2007">
                    <div className="bg-blue-500 h-3 rounded-full" style={{
                    width: '10%'
                  }} data-id="element-2008"></div>
                  </div>
                  <div className="w-8 text-right text-sm font-bold text-gray-900" data-id="element-2009">
                    1
                  </div>
                </div>
              </div>
            </div>

            {/* Policy Status */}
            <div className="bg-white rounded-xl border border-gray-200 p-6 shadow-sm" data-id="element-2010">
              <h3 className="text-lg font-semibold text-gray-900 mb-6" data-id="element-2011">
                Policy Status
              </h3>
              <div className="grid grid-cols-2 gap-4" data-id="element-2012">
                <div className="p-4 bg-gray-50 rounded-lg border border-gray-100" data-id="element-2013">
                  <div className="text-2xl font-bold text-gray-900" data-id="element-2014">24</div>
                  <div className="text-sm text-gray-500" data-id="element-2015">Active Policies</div>
                </div>
                <div className="p-4 bg-gray-50 rounded-lg border border-gray-100" data-id="element-2016">
                  <div className="text-2xl font-bold text-gray-900" data-id="element-2017">3</div>
                  <div className="text-sm text-gray-500" data-id="element-2018">Pending Review</div>
                </div>
                <div className="p-4 bg-gray-50 rounded-lg border border-gray-100" data-id="element-2019">
                  <div className="text-2xl font-bold text-gray-900" data-id="element-2020">98%</div>
                  <div className="text-sm text-gray-500" data-id="element-2021">Adoption Rate</div>
                </div>
                <div className="p-4 bg-gray-50 rounded-lg border border-gray-100" data-id="element-2022">
                  <div className="text-2xl font-bold text-gray-900" data-id="element-2023">15</div>
                  <div className="text-sm text-gray-500" data-id="element-2024">Auto-enforced</div>
                </div>
              </div>
            </div>
          </div>

          {/* Recent Violations Table */}
          <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden" data-id="element-2025">
            <div className="px-6 py-4 border-b border-gray-200 flex items-center justify-between" data-id="element-2026">
              <h2 className="text-lg font-semibold text-gray-900" data-id="element-2027">
                Recent Violations
              </h2>
              <button className="text-sm text-blue-600 font-medium hover:text-blue-700" data-id="element-2028">
                View All
              </button>
            </div>
            <table className="w-full text-left border-collapse" data-id="element-2029">
              <thead data-id="element-2030">
                <tr className="bg-gray-50 text-gray-500 text-xs uppercase tracking-wider" data-id="element-2031">
                  <th className="px-6 py-4 font-semibold" data-id="element-2032">Partner</th>
                  <th className="px-6 py-4 font-semibold" data-id="element-2033">Violation Type</th>
                  <th className="px-6 py-4 font-semibold" data-id="element-2034">Description</th>
                  <th className="px-6 py-4 font-semibold" data-id="element-2035">Severity</th>
                  <th className="px-6 py-4 font-semibold" data-id="element-2036">Date</th>
                  <th className="px-6 py-4 font-semibold" data-id="element-2037">Status</th>
                  <th className="px-6 py-4 font-semibold text-right" data-id="element-2038">Action</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100" data-id="element-2039">
                {VIOLATIONS.map(violation => <tr key={violation.id} className="hover:bg-gray-50 transition-colors" data-id="element-2040">
                    <td className="px-6 py-4" data-id="element-2041">
                      <div className="font-medium text-gray-900" data-id="element-2042">
                        {violation.partnerName}
                      </div>
                      <div className="text-xs text-gray-500" data-id="element-2043">
                        ID: {violation.partnerId}
                      </div>
                    </td>
                    <td className="px-6 py-4" data-id="element-2044">
                      <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-700" data-id="element-2045">
                        {violation.type}
                      </span>
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-600 max-w-xs truncate" data-id="element-2046">
                      {violation.description}
                    </td>
                    <td className="px-6 py-4" data-id="element-2047">
                      <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${violation.severity === 'Critical' ? 'bg-red-100 text-red-700' : violation.severity === 'High' ? 'bg-orange-100 text-orange-700' : violation.severity === 'Medium' ? 'bg-amber-100 text-amber-700' : 'bg-blue-100 text-blue-700'}`} data-id="element-2048">
                        {violation.severity === 'Critical' && <AlertTriangleIcon size={12} className="mr-1" data-id="element-2049" />}
                        {violation.severity}
                      </span>
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-500" data-id="element-2050">
                      {violation.date}
                    </td>
                    <td className="px-6 py-4" data-id="element-2051">
                      <span className={`inline-flex items-center gap-1.5 text-sm font-medium ${violation.status === 'Resolved' ? 'text-green-600' : violation.status === 'Investigating' ? 'text-blue-600' : 'text-red-600'}`} data-id="element-2052">
                        {violation.status === 'Resolved' ? <CheckCircleIcon size={14} data-id="element-2053" /> : violation.status === 'Investigating' ? <ClockIcon size={14} data-id="element-2054" /> : <AlertTriangleIcon size={14} data-id="element-2055" />}
                        {violation.status}
                      </span>
                    </td>
                    <td className="px-6 py-4 text-right" data-id="element-2056">
                      <button className="text-blue-600 hover:text-blue-800 text-sm font-medium" data-id="element-2057">
                        Details
                      </button>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>
      </main>

      <CreatePolicyModal isOpen={isCreatePolicyOpen} onClose={() => setIsCreatePolicyOpen(false)} data-id="element-2058" />
    </div>;
}